import HeaderContainer from '../container/HeaderContainer';
import ViewWrapper from './ViewWrapper';
import { RootRouter } from '../util/RouterUtil';
import FooterContainer from '../container/FooterContainer';
import { useEffect, useState } from 'react';
import AuthenticationUtil from '../util/AuthenticationUtil';
import { CODE_GROUP_ID } from '../constant/Constant';
import CodeUtil from '../util/CodeUtil';
import { useSelector } from 'react-redux';
import ConfigUtil from '../util/ConfigUtil';

const RootRouterView = () => {
    const webType = ConfigUtil.getWebType().toLowerCase();

    return (
        <div className={`wrap ${webType}`}>
            <HeaderContainer />
            <ViewWrapper router={RootRouter} />
            <FooterContainer />
        </div>
    );
};

export default RootRouterView;
